
import React from 'react';
import { SearchCode, BrainCircuit, ArrowRightLeft, History, Zap, FileUp, Camera, MessageSquare } from 'lucide-react';
import FeatureCard from '@/components/FeatureCard';

const features = [
  {
    icon: SearchCode,
    title: 'Access to 20+ LLM Models',
    description: 'Use models from OpenAI, Claude, Gemini, DeepSeek including the latest ones.',
  },
  {
    icon: ArrowRightLeft,
    title: 'Switch Between Models',
    description: 'Seamlessly switch between different models mid-conversation for the best results.',
  },
  {
    icon: MessageSquare,
    title: 'Compare Responses',
    description: 'Generate and compare answers from different LLMs side-by-side.',
  },
  {
    icon: History,
    title: 'Unified History',
    description: 'Maintain a single conversation history across all your models.',
  },
  {
    icon: Zap,
    title: 'Early Access',
    description: 'Get access to the latest models as soon as they are released.',
  },
  {
    icon: FileUp,
    title: 'Chat with Knowledge',
    description: 'Upload PDFs and other documents to chat with your data.',
  },
  {
    icon: Camera,
    title: 'Visual Understanding',
    description: 'Upload photos for context and visual analysis.',
  },
  {
    icon: BrainCircuit,
    title: 'Advanced AI Capabilities',
    description: 'Leverage the unique strengths of each model for different types of tasks.',
  },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="py-16 px-4">
      <div className="container mx-auto">
        <h2 className="text-3xl font-bold text-center mb-4">Everything You Need in One Place</h2>
        <p className="text-xl text-muted-foreground text-center max-w-2xl mx-auto mb-12">
          Access multiple AI models and capabilities through a single, intuitive interface
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
